import { Card, Col, Container, ListGroup, Row } from "react-bootstrap";
import { FaQuoteLeft } from "react-icons/fa";
import { FaQuoteRight } from "react-icons/fa";
import { SiTicktick } from "react-icons/si";
import BG from "../assets/Blue.png";
import Image from "../assets/IAM-Advisory-5.png";
import Footer from "../components/Footer";
import "../utils/effectCSS/Effects.css";

const IAMImplementationServices = () => {
  return (
    <>
      <Container
        fluid
        className="py-5"
        style={{
          backgroundImage: "url(" + BG + ")",
        }}
      >
        <div
          style={{
            height: "70px",
          }}
        ></div>
        <h2 className="text-center p-4">
          <b>IAM Implementation Services</b>
        </h2>

        <hr
          className="d-flex justify-content-center"
          style={{
            width: "10%",
            border: "1.5px solid blue",
            margin: "0 auto",
          }}
        />

        <div className="mt-5">
          <Row>
            <Col lg={2} className="d-flex justify-content-end">
              <FaQuoteLeft
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>

            <Col lg={8}>
              <Container fluid className="text-center">
                <p
                  style={{
                    fontSize: "1.25rem",
                  }}
                >
                  Tired of IAM challenges? Let IDM 360 Analytics transform your Identity Infrastructure and help you achieve seamless Security Today!
                </p>
              </Container>
            </Col>

            <Col
              lg={2}
              className="d-flex align-items-start justify-content-start"
            >
              <FaQuoteRight
                style={{
                  color: "#00FFFF",
                  fontSize: "25px",
                }}
              />
            </Col>
          </Row>
        </div>
        <Container>
          <Row className="mt-5">
            <Col className="d-flex" lg={6}>
              <img className="img-fluid" src={Image} alt="IAM" />
            </Col>
            <Col lg={6}>
              <Container
                style={{
                  backgroundColor: "#6495ED",
                  color: "white",
                  padding: "5rem 4rem",
                }}
              >
                <h3 className="">
                  Simplify IAM challenges with IDM 360 Analytics
                </h3>

                <div className="mt-4">
                  <ListGroup className="border-0 bg-transparent ">
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Tailored IAM Solutions: We provide customized Identity and Access Management (IAM) solutions.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Seamless Integration: Our experts ensure smooth integration of IAM systems with your existing Infrastructure.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Streamlined User Access: We simplify access management, enhancing security while improving user experience and productivity.
                    </ListGroup.Item>
                    <ListGroup.Item className="border-0 bg-transparent text-white">
                      <SiTicktick className="me-3" />
                      Scalable Solutions: As your business grows, our IAM services evolve with you, Ensuring long-term Security and Efficiency.
                    </ListGroup.Item>
                  </ListGroup>
                </div>
              </Container>
            </Col>
          </Row>
        </Container>
        <Card className="bg-transparent border border-0 text-black p-5 text-center">
          <Card.Body>
            <h3 className="text-center mb-4">
              <b>
                IAM Expertise Unlocks Solutions To Changing Risks
              </b>
            </h3>
            <hr
              className="d-flex justify-content-center"
              style={{
                width: "10%",
                border: "1.5px solid blue",
                margin: "0 auto",
              }}
            />
            <Container>
              <Row xs={1} lg={3}>
                <Col lg={2}></Col>
                <Col lg={8} className="mt-4">
                  <p
                    style={{
                      fontSize: "1.25rem",
                    }}
                  >
                    Our deep IAM expertise enables us to provide adaptive solutions that address the evolving landscape of security risks. By managing user identities and access with precision, we reduce vulnerabilities and mitigate potential threats. Our solutions are designed to stay ahead of Compliance Requirements, Ensuring that your Organization remains secure in the face of new challenges.                  </p>
                </Col>
                <Col lg={2}></Col>
              </Row>
            </Container>
          </Card.Body>
        </Card>

        <Container className="p-0">
          {/* First Row */}
          <Row className="justify-content-center g-3 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>IAM Solutions Architecture</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                 we design and implement robust IAM Solutions Architecture tailored to your organization's specific needs. Our team combines industry best practices with innovative technologies to Create Scalable, Secure, and Flexible IAM frameworks that seamlessly integrate with your existing Infrastructure.
                </p>
              </Container>
            </Col>
          </Row>

          {/* Second Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={6} className="d-flex order-2 order-lg-1 hover-left">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                  IDM 360 Analytics offers specialized IAM Staff Augmentation services to enhance your organization's security capabilities. Whether you need temporary resources for a project or long-term Support, our Professionals help you manage and optimize your Identity and Access Management Systems effectively.
                </p>
              </Container>
            </Col>

            <Col lg={4} className="d-flex order-1 order-lg-2 hover-right">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#1ca9c9",
                  color: "white",
                }}
              >
                <h5>IAM Staff Augmentation</h5>
              </Container>
            </Col>
          </Row>

          {/* Third Row */}
          <Row className="justify-content-center g-3 mt-1 align-items-stretch">
            <Col lg={4} className="d-flex hover-left">
              <Container
                className="flex-fill text-center"
                style={{
                  padding: "4rem",
                  backgroundColor: "#3457D5",
                  color: "white",
                }}
              >
                <h5>Migration and Evolution</h5>
              </Container>
            </Col>

            <Col lg={6} className="d-flex hover-right">
              <Container
                className="flex-fill border border-1 shadow-lg"
                style={{
                  padding: "2rem",
                  backgroundColor: "white",
                  fontSize: "13px",
                }}
              >
                <p>
                IDM 360 Analytics's IAM migration and transformation services offer a complete package that includes IAM integration, support service desk, help desk, and SOC. Our solutions also cover IAM process Definition, Re-engineering, Deployment, and the Implementation of an advanced NextGen IAM framework.
                </p>
              </Container>
            </Col>
          </Row>
        </Container>
      </Container>
      <div className="mt-4">
        <Footer />
      </div>
    </>
  );
};

export default IAMImplementationServices;
